import { Component, Input, OnDestroy, ViewEncapsulation } from '@angular/core';
import { Subject } from 'rxjs';
import { filter, map, shareReplay, takeUntil } from 'rxjs/operators';
import { ClassroomCourseApiService } from '../../store/services/classroom-course.api.service';
import {  Review } from '@shared/models/review';
import { ClassroomCourse } from '../../models/classroom-course';
import { TRANSLATION_SCOPE } from '../../i18n/scope';

@Component({
  selector: 'app-course-reviews',
  templateUrl: './course-reviews.component.html',
  styleUrls: ['./course-reviews.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class CourseReviewsComponent implements OnDestroy {

  @Input() course: ClassroomCourse;

  @Input() reviews:  Review[] = [];
  @Input() reviewsTitle: string;
  @Input() reviewTotalCount: number;

  reviewPageCount = 1;
  reviewPageOffset = 3;

  translationScope = TRANSLATION_SCOPE;

  private destroy$: Subject<any>;

  constructor(
    private classroomCourseApi: ClassroomCourseApiService,
  ) {
    this.destroy$ = new Subject();
   }


  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }



  public loadReviews(): void {
    this.classroomCourseApi
      .getClassroomCourseReviews(this.course.id, this.reviewPageCount++, this.reviewPageOffset)
      .pipe(
        shareReplay(1),
        filter(reviewList => Boolean(reviewList.items?.length && reviewList.items.length > 0)),
        takeUntil(this.destroy$),
        map((list) => {
          return list.items;
        })
      ).subscribe((response) =>{
          this.reviews = this.reviews.concat(response)
      });
  }

}
